module.exports = __webpack_public_path__ + "static/media/top_prod_2.b1e20f5c.png";